export enum GlobalSearchBarType {
  SUPPORT_ARTICLE = 'support_article',
}

export interface GlobalSearchBarDetails {
  keyword: string
  to: string
  external?: boolean
  tags?: string[]
  linkType?: GlobalSearchBarType
  suggestedScore?: number
  group?: string
}
